import React from "react";
import Modal from "react-bootstrap/Modal";
import { formatDayMonth } from "utils/formatDate";
//import DatePicker from "react-date-picker";
import DatePicker from "react-datepicker";
import ReactDropdown from "react-dropdown";
import { ChoVayCombo } from "constants/choVayConst";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import { currentDate } from "utils/formatDate";
import { convertDate } from "utils/formatDate";
import { postTraGopSuccess } from "actions/ThemMoiTraGop";
import themMoiTinChapReducer from "reducers/themMoiTinChapReducer";
import handleEscapeKey from "../../../utils/handleEscapeKey";

class SearchChoVay extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: props.show || false, // Trạng thái popup
      choVay: {},
      dataSearch: {
        dateFrom: "01/01/2001",
        dateTo: "01/01/4000",
        code: "",
        customerName: "",
        address: "",
        noteTaiSan: "",
        status: "5",
        debt: "-1",
        userName: "",
        pageIndex: 1,
        pageSize: 20,
        ThoiGian: "",
        taiSan: 0,
        dongtungay: "01/01/2001",
        dongdenngay: "01/01/4000",
      },
      statusHopDong: 0,
    };
    this.toggleModal = this.props.onHide.bind(this);
    // Tạo instance của useEscapeKey và gán vào this.escListener
    this.escListener = handleEscapeKey(this.props.onHide);
  }

  componentDidMount() {
    // Thêm listener chỉ khi modal mở
    if (this.state.isModalOpen) this.escListener.addListener();
  }

  componentWillUnmount() {
    // Gỡ listener khi component unmount
    this.escListener.removeListener();
  }

  toggleModal() {
    // Cập nhật trạng thái popup và thêm/xóa listener khi cần
    this.setState(
      (prevState) => ({ isModalOpen: !prevState.isModalOpen }),
      () => {
        if (this.state.isModalOpen) {
          this.escListener.addListener();
        } else {
          this.escListener.removeListener();
        }
      }
    );
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.data !== prevState.dataSearch) {
      return { dataSearch: nextProps.data };
    } else return null;
  }
  onChangeData = (field) => (event) => {
    let { dataSearch } = this.state;
    dataSearch[field] = event.target.value;
    this.setState(dataSearch);
  };

  _onSelect = (field) => (value) => {
    let { dataSearch } = this.state;
    dataSearch[field] = value.value;
    this.setState({ dataSearch });
    if (field === "status") {
      this.setState({
        statusHopDong: value.value,
      });
    }
  };
  onChangeDate = (field) => (evt) => {
    let { dataSearch } = this.state;
    dataSearch[field] = formatDayMonth(evt);
    this.setState({ dataSearch });
  };
  onHide = () => {
    this.setState({ isModalOpen: false });
    this.props.onHide();
  };
  onSearch = () => {
    let props = this.props;
    let { dataSearch } = this.state;
    if (!dataSearch.dateFrom) dataSearch.dateFrom = "01/01/2001";
    if (!dataSearch.dateTo) dataSearch.dateTo = "01/01/4000";

    if (!dataSearch.dongtungay) dataSearch.dongtungay = "01/01/2001";
    if (!dataSearch.dongdenngay) dataSearch.dongdenngay = "01/01/4000";

    props.onHide(dataSearch);
    this.setState({ dataSearch });
  };
  onKeyDownDate = (field) => (evt, evt1) => {
    let { dataSearch } = this.state;
    if (evt.keyCode === 8) dataSearch[field] = "";
    this.setState({ dataSearch });
  };

  render() {
    let props = this.props;
    let { show, type, trangs } = props;
    let { dataSearch } = this.state;
    var dateFrom = currentDate();
    if (dataSearch.dateFrom === "01/01/2001") dateFrom = "";
    else dateFrom = dataSearch.dateFrom;
    var dateTo = currentDate();
    if (dataSearch.dateTo === "01/01/4000") dateTo = "";
    else dateTo = dataSearch.dateTo;
    dateTo = convertDate(dateTo);
    dateFrom = convertDate(dateFrom);

    var dongtungay = currentDate();
    if (dataSearch.dongtungay === "01/01/2001") dongtungay = "";
    else dongtungay = dataSearch.dongtungay;
    var dongdenngay = currentDate();
    if (dataSearch.dongdenngay === "01/01/4000") dongdenngay = "";
    else dongdenngay = dataSearch.dongdenngay;
    dongtungay = convertDate(dongtungay);
    dongdenngay = convertDate(dongdenngay);
    return (
      <Modal
        show={show}
        onHide={this.onHide}
        size="modal-dialog modal-lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-new modal fade text-left"
      >
        <Modal.Header>
          <h4 class="modal-title  color7-bold" id="myModalLabel16">
            <span class="btn-icon-right">
              <img src="/app-assets/images/icon-tim-kiem-nang-cao.png" />
            </span>
            Bộ lọc nâng cao
          </h4>
          <button
            type="button"
            className="close-popup-new"
            onClick={this.onHide}
          >
            <img src="/app-assets/images/icon-dong-popup-v2.png" />
          </button>
        </Modal.Header>
        <Modal.Body className="">
          <div class="row repeater-default">
            <div class="form-group mb-1 col-sm-12 col-md-12">
              <label for="email-addr" className="color7-bold">
                Tìm kiếm
              </label>
              <br />
              <input
                type="text"
                className="form-control input-sm "
                placeholder="Tên, sđt khách hàng"
                onChange={this.onChangeData("customerName")}
                value={dataSearch.customerName}
              />
            </div>
          </div>
          <div class="row repeater-default">
            <div class="form-group mb-1 col-sm-12 col-md-6">
              <label for="tel-input">Từ ngày</label>
              <br />
              <DateTimePicker
                value={dateFrom}
                onChange={this.onChangeDate("dateFrom")}
                onKeyDown={this.onKeyDownDate("dateFrom")}
              ></DateTimePicker>
            </div>
            <div class="form-group mb-1 col-sm-12 col-md-6">
              <label for="tel-input">Đến ngày</label>
              <br />
              <DateTimePicker
                value={dateTo}
                onChange={this.onChangeDate("dateTo")}
                onKeyDown={this.onKeyDownDate("dateTo")}
              ></DateTimePicker>
            </div>
          </div>
          <div class="row repeater-default">
            <div class="form-group mb-1 col-sm-12 col-md-6">
              <label for="tel-input">Trạng thái</label>
              <br />
              <ReactDropdown
                onChange={this._onSelect("status")}
                options={ChoVayCombo.StatusCombo}
                placeholder="Tất cả"
                controlClassName="form-control input-sm"
                arrowClassName=""
                value={dataSearch.status}
              />
            </div>
            {type === 3 ? (
              <div class="form-group mb-1 col-sm-12 col-md-6">
                <label for="tel-input">Mã tài sản</label>
                <br />
                <input
                  type="text"
                  className="form-control input-sm"
                  onChange={this.onChangeData("code")}
                  // onKeyDown={this.handleKeyDown}
                  value={dataSearch.code}
                />
              </div>
            ) : (
              <div class="form-group mb-1 col-sm-12 col-md-6">
                <label for="profession">Hợp đồng</label>
                <br />
                <ReactDropdown
                  onChange={this._onSelect("taiSan")}
                  options={ChoVayCombo.HopDongCombo}
                  placeholder="Tất cả"
                  controlClassName="form-control input-sm"
                  value={dataSearch.taiSan}
                />
              </div>
            )}
          </div>
          <div class="row repeater-default">
            <div class="form-group mb-1 col-sm-12 col-md-6">
              <label for="tel-input">Địa chỉ</label>
              <br />
              <input
                type="text"
                className="form-control input-sm"
                onChange={this.onChangeData("address")}
                // onKeyDown={this.handleKeyDown}
                value={dataSearch.address}
              />
            </div>
            <div class="form-group mb-1 col-sm-12 col-md-6">
              <label for="profession">Người tạo hợp đồng</label>
              <ReactDropdown
                onChange={this._onSelect("userName")}
                options={props.userCombo}
                placeholder="Tất cả"
                controlClassName="form-control input-sm"
                value={dataSearch.userName}
              />
            </div>
          </div>
          <div class="row repeater-default">
            <div class="form-group mb-1 col-sm-12 col-md-6">
              <label for="profession">Tình trạng</label>
              <br />
              <ReactDropdown
                onChange={this._onSelect("debt")}
                options={props.listTinhTrangNo}
                placeholder="Tất cả"
                controlClassName="form-control input-sm"
                value={dataSearch.debt}
              />
            </div>
            {type === 3 && (
              <div class="form-group mb-1 col-sm-12 col-md-6">
                <label>Thuộc tính tài sản</label>
                <br />
                <input
                  type="text"
                  className="form-control input-sm"
                  onChange={this.onChangeData("noteTaiSan")}
                  // onKeyDown={this.handleKeyDown}
                  value={dataSearch.noteTaiSan}
                />
              </div>
            )}
            {this.state.statusHopDong == "2" &&
              (trangs === "TraGop" || trangs === "CamDo") && (
                <div class="form-group mb-1 col-sm-12 col-md-6">
                  <label>Hợp đồng đóng từ ngày</label>
                  <br />
                  <DateTimePicker
                    value={dongtungay}
                    onChange={this.onChangeDate("dongtungay")}
                    onKeyDown={this.onKeyDownDate("dongtungay")}
                  ></DateTimePicker>
                </div>
              )}
            {this.state.statusHopDong == "2" &&
              (trangs === "TraGop" || trangs === "CamDo") && (
                <div class="form-group mb-1 col-sm-12 col-md-6">
                  <label>Đến ngày</label>
                  <br />
                  <DateTimePicker
                    value={dongdenngay}
                    onChange={this.onChangeDate("dongdenngay")}
                    onKeyDown={this.onKeyDownDate("dongdenngay")}
                  ></DateTimePicker>
                </div>
              )}
          </div>
        </Modal.Body>
        <Modal.Footer className="text-right">
        <button
            type="button"
            className="btn btn-new-main btn-closenew"
            onClick={this.onHide}
          >
            <span>
              <i class="mdi mdi-close"></i>
            </span>{" "}
            Đóng
          </button>
          <button
            type="button"
            class="btn btn-new-main btn-checknew"
            onClick={this.onSearch}
          >
            <span>
              <i class="mdi mdi-magnify"></i>
            </span>{" "}
            Tìm kiếm
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}
export default SearchChoVay;
